// client/customer/src/utils/reservation/by-service/fetchStaffServiceDurations.ts
import apiConfig from '../../../apiConfig';

export type StaffServiceDurationRow = {
  service_id: number;
  duration_minutes: number;
};

export type FetchStaffServiceDurationsResponse = {
  durations: StaffServiceDurationRow[];
};

export const fetchStaffServiceDurations = async (
  staffId: number,
  serviceIds: number[],
): Promise<StaffServiceDurationRow[]> => {
  if (!Number.isFinite(staffId) || staffId <= 0) throw new Error('Invalid staffId');
  if (!Array.isArray(serviceIds) || serviceIds.length === 0) throw new Error('Invalid serviceIds');

  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-service/staff-service-durations`);
  url.searchParams.set('staff_id', String(staffId));
  url.searchParams.set('service_ids', serviceIds.join(','));

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch staff service durations');
  }

  const data = (await res.json()) as FetchStaffServiceDurationsResponse;
  return Array.isArray(data.durations) ? data.durations : [];
};
